"use client";

import { c as _c } from "react/compiler-runtime";
import { FiUsers } from "react-icons/fi";
const SUGGESTIONS = ["First-line, treatment-naive patients", "After failure of standard-of-care", "Patients with comorbidities (e.g. CKD, hepatic impairment)", "Specific age band (pediatric / geriatric)", "Patients with adherence challenges", "Other"];
const MIN_LENGTH = 5;
const PatientPopulation = t0 => {
  const $ = _c(35);
  const {
    patientPopulation,
    setPatientPopulation,
    productName,
    onBack,
    onNext
  } = t0;
  const t1 = patientPopulation || "";
  let t2;
  if ($[0] !== t1) {
    t2 = t1.trim();
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const trimmed = t2;
  const isFormValid = trimmed.length >= MIN_LENGTH;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex items-center gap-2 sm:gap-3 mb-2"><div className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg bg-primary-primaryBlue/10 flex items-center justify-center flex-shrink-0"><FiUsers className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-primary-primaryBlue" /></div><h2 className="text-base sm:text-xl font-bold text-gray-900 font-poppins">Patient Population</h2></div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = productName || "this therapy";
  let t5;
  if ($[3] !== t4) {
    t5 = <p className="text-xs sm:text-sm text-gray-600 font-poppins mb-4 sm:mb-6">Which patients would you consider <span className="font-semibold">{t4}</span> for once available?</p>;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== patientPopulation || $[6] !== setPatientPopulation) {
    t6 = SUGGESTIONS.map(s => {
      const parts = (patientPopulation || "").split(/\s*;\s*/).filter(Boolean);
      const active = parts.some(p => p.toLowerCase() === s.toLowerCase());
      const toggle = () => {
        if (active) {
          const next = parts.filter(p_0 => p_0.toLowerCase() !== s.toLowerCase()).join("; ");
          setPatientPopulation(next);
        } else {
          const current = (patientPopulation || "").trim();
          setPatientPopulation(current ? `${current}; ${s}` : s);
        }
      };
      return <button key={s} type="button" onClick={toggle} aria-pressed={active} className={`inline-flex items-center px-3 py-1.5 rounded-full text-[11px] sm:text-xs font-medium font-poppins border transition-colors ${active ? "bg-primary-primaryBlue text-white border-primary-primaryBlue" : "bg-gray-50 text-gray-700 border-gray-200 hover:bg-gray-100"}`}>{s}</button>;
    });
    $[5] = patientPopulation;
    $[6] = setPatientPopulation;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t6) {
    t7 = <div className="flex flex-wrap gap-2 mb-4">{t6}</div>;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <label className="block text-xs sm:text-sm font-medium text-gray-900 font-poppins mb-2"><span className="font-semibold">Describe the population</span></label>;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const t9 = patientPopulation || "";
  let t10;
  if ($[11] !== setPatientPopulation) {
    t10 = e => setPatientPopulation(e.target.value);
    $[11] = setPatientPopulation;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t9) {
    t11 = <textarea value={t9} onChange={t10} placeholder="e.g. Adult patients with type-2 diabetes inadequately controlled on metformin" className="w-full rounded-lg border-2 border-gray-200 focus:border-primary-primaryBlue focus:outline-none transition-colors p-3 sm:p-4 resize-none text-xs sm:text-sm font-poppins" rows={4} />;
    $[13] = t10;
    $[14] = t9;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <p className="mt-3 sm:mt-4 text-xs sm:text-sm text-gray-500 font-poppins">Minimum {MIN_LENGTH} characters. Suggestions above are optional shortcuts.</p>;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t11 || $[18] !== t7) {
    t13 = <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-4 sm:p-6">{t7}{t8}{t11}{t12}</div>;
    $[17] = t11;
    $[18] = t7;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t13 || $[21] !== t5) {
    t14 = <div className="flex-1 overflow-y-auto hide-scrollbar px-4 sm:px-6 py-3 sm:py-4"><div className="mb-4 sm:mb-6">{t3}{t5}{t13}</div></div>;
    $[20] = t13;
    $[21] = t5;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== onBack) {
    t15 = <button onClick={onBack} className="flex-1 border-2 border-gray-300 text-gray-700 text-sm sm:text-base font-semibold font-poppins rounded-lg py-2.5 sm:py-3 hover:bg-gray-50 transition-colors">Back</button>;
    $[23] = onBack;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  const t16 = !isFormValid;
  const t17 = `flex-1 text-white rounded-lg text-sm sm:text-base font-semibold font-poppins py-2.5 sm:py-3 transition-all ${isFormValid ? "bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 shadow-md hover:shadow-lg transform hover:scale-[1.02]" : "bg-gray-300 cursor-not-allowed"}`;
  let t18;
  if ($[25] !== onNext || $[26] !== t16 || $[27] !== t17) {
    t18 = <button onClick={onNext} disabled={t16} className={t17}>Next</button>;
    $[25] = onNext;
    $[26] = t16;
    $[27] = t17;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== t15 || $[30] !== t18) {
    t19 = <div className="px-4 sm:px-6 py-3 sm:py-4 border-t border-gray-200 bg-white flex gap-2 sm:gap-3 flex-shrink-0">{t15}{t18}</div>;
    $[29] = t15;
    $[30] = t18;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] !== t14 || $[33] !== t19) {
    t20 = <>{t14}{t19}</>;
    $[32] = t14;
    $[33] = t19;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  return t20;
};
export default PatientPopulation;